(() => {
  const video = document.querySelector('#home-builder video');
  if (!video) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const desktopPoster = video.poster;
  let visible = false;
  const updatePlayback = () => {
    video.poster = mobile.matches ? video.dataset.mobilePoster : desktopPoster;
    if (!visible || document.hidden || reducedMotion.matches) {
      video.pause();
      if (reducedMotion.matches && video.hasAttribute('src')) {
        video.removeAttribute('src');
        video.load();
      }
      return;
    }
    const source = mobile.matches ? video.dataset.mobileSrc : video.dataset.src;
    if (video.getAttribute('src') !== source) {
      video.setAttribute('src', source);
      video.load();
    }
    video.play().catch(() => { /* Keep the poster if autoplay is unavailable. */ });
  };
  const observer = new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    updatePlayback();
  }, { threshold: .2 });
  observer.observe(video);
  document.addEventListener('visibilitychange', updatePlayback);
  reducedMotion.addEventListener('change', updatePlayback);
  mobile.addEventListener('change', updatePlayback);
  updatePlayback();
})();
